import React, { useState } from 'react'
import EditTask from '../modals/EditTask';
import { useTodoContext } from '../context/TodoContext';
import IconButton from '@mui/material/IconButton';
import Favorite from '@mui/icons-material/Favorite';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Checkbox from '@mui/material/Checkbox';
const TaskCard = ({ taskObj, index }) => {
    const { deleteTask, updateListArray,upddateFav} = useTodoContext();
    const [modal, setModal] = useState(false);
    const [fav,setFav]=useState(false)
   
    const toggle = () => setModal(!modal);
    const colors = [
        {
            primaryColor: "#5D93E1",
            secondaryColor: "#ECF3FC"
        },
        {
            primaryColor: "#F9D288",
            secondaryColor: "#FEFAF1"
        },
        {
            primaryColor: "#5DC250",
            secondaryColor: "#F2FAF1"
        },
        {
            primaryColor: "#F48687",
            secondaryColor: "#FDF1F1"
        },
        {
            primaryColor: "#B964F7",
            secondaryColor: "#F3F0FD"
        }
    ]

    const handleDelete = (index) => {
        deleteTask(index)
    }

    const updateTask = (task) => {
        updateListArray(task, index);
    }
   
    const favTask=()=>{
        setFav(!fav);      
    }

    const updateFav=()=>{
        upddateFav(index,fav)
    }
   
    console.log(`id:${index} ,fav ${fav}`)
    return (
        <div class="card-wrapper mr-5">
            <div class="card-top" style={{ "background-color": colors[index % 5].primaryColor }}></div>
            <div class="task-holder">
                <span class="card-header" style={{ "background-color": colors[index % 5].secondaryColor, "border-radius": "10px" }}>{taskObj.name}</span>
                <p className="mt-3">{taskObj.description}</p>

                <div style={{ "position": "absolute", "right": "20px", "bottom": "20px" }}>
                    <i class="far fa-edit mr-3" style={{ "color": colors[index % 5].primaryColor, "cursor": "pointer", margin: "10px" }} onClick={() => setModal(true)}></i>
                    <i class="fas fa-trash-alt" style={{ "color": colors[index % 5].primaryColor, "cursor": "pointer", margin: "10px" }} onClick={handleDelete} ></i>
                    <IconButton aria-label="add to favorites">
                        <Checkbox icon={<FavoriteBorder />} checkedIcon={<Favorite sx={{ "color": colors[index % 5].primaryColor}} />} onChange={favTask} />
                    </IconButton>
                </div>
            </div>
            <EditTask modal={modal} toggle={toggle} update={updateTask} taskObj={taskObj} index={index} />
        </div>
    )
}

export default TaskCard